import React from 'react';
import { UserState } from '../../../../../utils/apollo/graphqlSchema';
import InlineMultiSelectMenu from '../../../../../components/Builder/InlineMultiSelectMenu';
import UsersFilterLabel from './UsersFilterLabel';
import { userStatesLabelLookup } from '../../utils/userStatesConfig';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';

interface IProps {
  states: UserState[];
  setStates: (states: UserState[]) => void;
}

const UserStatusFilter = ({ states, setStates }: IProps) => {
  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Status</BuilderUI.BuilderFieldLabel>
      <InlineMultiSelectMenu
        label={
          <UsersFilterLabel
            selectedValues={states.map((state) => userStatesLabelLookup[state])}
          />
        }
        labelIsAlwaysActive={true}
        options={Object.values(UserState).map((state) => ({
          label: userStatesLabelLookup[state],
          value: state,
        }))}
        selectedKeys={states}
        onSubmit={setStates}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default UserStatusFilter;
